import { render } from "./FlightRequest.vue?vue&type=template&id=0487409d"
import script from "./FlightRequest.vue?vue&type=script&lang=js"
export * from "./FlightRequest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__